import React, { Component } from "react";
import "./ScheduleEntry.css";
import { Link } from "react-router-dom";

import HeaderCard from "./HeaderCard";

class ScheduleEntryTitle extends Component {
  render() {
    return (
      <div className="schedule-menu-wrapper">
        <div className="schedule-menu">
          <Link to="/app/student-dashboard/basicinfo">
            <HeaderCard
              headerClass="orange half"
              headerLabel=""
              headerValue="Basic Info"
            />
          </Link>
          <Link to="/app/student-dashboard/packages">
            <HeaderCard
              headerClass="magenta half"
              headerLabel=""
              headerValue="Packages / Plans"
            />
          </Link>
          <Link to="/app/student-dashboard/payments">
            <HeaderCard
              headerClass="cyan half"
              headerLabel=""
              headerValue="Payment / Balances"
            />
          </Link>
          <Link to="/app/student-dashboard/lessons">
            <HeaderCard
              headerClass="red half"
              headerLabel=""
              headerValue="Lessons"
            />
          </Link>
          <Link to="/app/student-dashboard/roadtests">
            <HeaderCard
              headerClass="green half"
              headerLabel=""
              headerValue="Road Tests"
            />
          </Link>
          <Link to="/app/student-dashboard/fivehourclass">
            <HeaderCard
              headerClass="teal half"
              headerLabel=""
              headerValue="5hr. Class Info"
            />
          </Link>
        </div>
      </div>
    );
  }
}

export default ScheduleEntryTitle;
